import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Cell } from '../../Table'
import { DropDown, DropDownItem, ICONS } from '../../DropDown'
import { getMessage } from 'lib/translator'

// Validate merchant ID: allow only letters, numbers, underscore, hyphen
const isSafeId = (val) =>
  typeof val === 'string' && /^[A-Za-z0-9_-]+$/.test(val)

const EditLink = ({ id, children }) => {
  if (!isSafeId(id)) {
    return <span>{children}</span>
  }
  return <Link to={`/rewards/merchants/edit/${id}`}>{children}</Link>
}

export const tableProperties = {
  headers: ['CLS Merchant ID', 'Name', 'Actions'],
  row: ({ clsMerchantID, name }) => (
    <Row>
      <Cell className="rewards-page-actions column-id">
        <EditLink id={clsMerchantID}>{String(clsMerchantID)}</EditLink>
      </Cell>
      <Cell className="rewards-page-actions column-name">
        <EditLink id={clsMerchantID}>{name}</EditLink>
      </Cell>
      <Cell className="rewards-page-actions column-actions">
        <DropDown icon={<img src={ICONS.VELLIP} alt="⋮" />}>
          <EditLink id={clsMerchantID}>
            <DropDownItem>{getMessage('rewards.merchant.edit')}</DropDownItem>
          </EditLink>
        </DropDown>
      </Cell>
    </Row>
  ),
}
